import { GoogleEvent, GoogleEventList, IGoogleCalendar } from '@app/googlecalendar'
import { createContext } from 'react'

export class CalendarContextType {
	api!: IGoogleCalendar
	getEventsForDate!: (startDate: string) => Promise<GoogleEventList>
	selectedDate!: string
	setSelectedDate!: (date: Date | string) => void
	getStartDateForMonth!: (date: string) => string
	formatDate!: (date: string | Date) => string
	editEvent!: (event: GoogleEvent) => Promise<void>
	addEvent!: (date: string | Date) => Promise<void>
	deleteEvent!: (event: GoogleEvent) => Promise<void>
}
export const CalendarContext = createContext(new CalendarContextType())
